import { render } from "./QuizQuestions.vue?vue&type=template&id=469d7d66&scoped=true"
import script from "./QuizQuestions.vue?vue&type=script&lang=js"
export * from "./QuizQuestions.vue?vue&type=script&lang=js"

import "./QuizQuestions.vue?vue&type=style&index=0&id=469d7d66&scoped=true&lang=css"

import exportComponent from "/home/admin/sites/imdibil.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-469d7d66"]])

export default __exports__